import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.09467 13.0947C4.80178 13.3876 4.80178 13.8624 5.09467 14.1553L11.3447 20.4053C11.6376 20.6982 12.1124 20.6982 12.4053 20.4053L18.6553 14.1553C18.9482 13.8624 18.9482 13.3876 18.6553 13.0947C18.3624 12.8018 17.8876 12.8018 17.5947 13.0947L12.625 18.0643L12.625 3.625C12.625 3.21079 12.2892 2.875 11.875 2.875C11.4608 2.875 11.125 3.21079 11.125 3.625L11.125 18.0643L6.15533 13.0947C5.86244 12.8018 5.38756 12.8018 5.09467 13.0947Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgArrowDown;
